import { useHomeScreenConfig } from '@tovala/browser-apis-cdn'
import { events, sourceIDs } from 'analytics/events'
import { useOverlays } from 'contexts/overlays'
import { track } from 'utils/analytics'

const ReferralBanner = () => {
  const { setIsReferralModalOpen } = useOverlays()

  const { data: homeScreenConfig } = useHomeScreenConfig()
  const { referralBanner } = homeScreenConfig || {}

  if (referralBanner) {
    const { title, subtitle, heroImage } = referralBanner
    return (
      <button
        className="block w-full text-left"
        onClick={() => {
          setIsReferralModalOpen(true)
          track(events.OPENS_REFERRAL_SCREEN, {
            source_id: sourceIDs.ORDER_TAB,
          })
        }}
        type="button"
      >
        <span className="flex h-56 overflow-hidden rounded-xl bg-white md:h-20">
          <span className="w-1/3 pb-4 pr-6 pt-8 md:pb-2 md:pr-2 md:pt-4">
            <img
              alt=""
              className="h-full w-full object-cover object-right"
              src={heroImage}
            />
          </span>
          <span className="flex w-2/3 items-center pl-6 md:pl-3">
            <span className="space-y-2 md:space-y-1">
              <span className="block text-k/28_110 font-semibold md:text-k/16_125">
                {title}
              </span>
              <span className="block text-k/16_125 md:text-k/12_120">
                {subtitle}
              </span>
            </span>
          </span>
        </span>
      </button>
    )
  }

  return null
}

export default ReferralBanner
